export function normalizeStopDescription(description) {
  if (description == null) {
    return null;
  }

  const normalized = String(description).trim();

  if (!normalized || normalized.toLowerCase() === "null") {
    return null;
  }

  return normalized;
}
